import { Theme } from "@amx/ux-twoui-theming";
import { IStackStyles } from "@fluentui/react";

export const foregroundCircleDimension = "12.25vw";
export const foregroundImageDimension = "6.12vw";

export const foregroundWrapperStyles: IStackStyles = {
    root: {
        position: "absolute",
        bottom: `-${foregroundImageDimension}`,
        width: "100%"
    }
};

export const foregroundCircleStyles = (theme: Theme): IStackStyles => ({
    root: {
        backgroundColor: theme.palette.neutralHigh,
        borderRadius: "50%",
        width: foregroundCircleDimension,
        height: foregroundCircleDimension
    }
});

export const foregroundImageStyles = {
    root: {
        width: foregroundImageDimension,
        height: foregroundImageDimension
    }
};
